import React from "react";
import { cn } from "@/lib/utils";

interface PageProps {
  children: React.ReactNode;
  className?: string;
}

const Page: React.FunctionComponent<PageProps> = ({ children, className }) => {
  return <div className={cn("pt-20", className)}>{children}</div>;
};

export default Page;
